<template>
  <div v-if="showDesktopDoctorCard" class="xl:w-1/2 hidden xl:block px-12">
    <MainContent paddingClass="py-6 px-6">
      <div id="checkout-summary-panel" class="space-y-6"></div>
      <div id="checkout-debug-panel" class="mt-6 space-y-6"></div>
    </MainContent>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MainContent from '@/components/design/mainContent.vue';

export default defineComponent({
  name: 'CheckoutRightPane',
  components: {
    MainContent,
  },
  props: {
    showDesktopDoctorCard: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
